import Navbar from '../components/layout/Navbar';
import AddAffiliationForm from '../components/layout/AddAffiliationForm';
import styles from './styles/AddAffiliationPage.module.css';

export default function AddAffiliationPage() {
  return (
    <div className={styles.container}>
      <Navbar />
      <div className='container'>
        <br />
        <h2>Add an Affiliation</h2>
        <AddAffiliationForm />
      </div>
    </div>
  );
}
